import { z } from 'zod';
import { TagSchema } from '../tag.js';
export const ListTagsByResourceRequestSchema = TagSchema.pick({ resourceCorn: true });
export const ListTagsByKeyRequestSchema = TagSchema.pick({ key: true });
export const ListTagsByFilterRequestSchema = z.object({
    service: z.string(),
    resourceType: z.string().optional(),
});
export const ListTagsQueryStringRequestSchema = ListTagsByFilterRequestSchema.merge(ListTagsByResourceRequestSchema)
    .merge(ListTagsByKeyRequestSchema)
    .partial();
export const ListTagsRequestSchema = ListTagsQueryStringRequestSchema;
export const ListFullTagsResponseSchema = z.array(TagSchema);
export const ListTagKeysResponseSchema = z.array(z.string());
export const ListTagsResponseSchema = ListFullTagsResponseSchema.or(ListTagKeysResponseSchema);
